import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS5() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs5.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS5
